import { useMutation, useQueryClient } from '@tanstack/react-query';

import envVars from '../../../constants/envVars';
import { useSetNotification } from '../../../context/Notification';
import useRequest from '../../../hooks/useRequest';
import { MemberCheckinPayload } from '../types';
import { ORGANIZATION_MEMBER_KEY } from './constants';

const useMemberCheckin = (onSuccess?: () => void) => {
    const req = useRequest();
    const queryClient = useQueryClient();
    const setNotification = useSetNotification();

    const request = ({ payload }: { payload: MemberCheckinPayload }) => {
        return req({
            url: `${envVars.API_COMMERCE_HOSTNAME}enterprise/member-checkin/`,
            method: 'PUT',
            body: JSON.stringify(payload)
        });
    };

    return useMutation({
        mutationFn: request,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [ORGANIZATION_MEMBER_KEY] });
            setNotification({ message: `Member checkin updated` });
            onSuccess && onSuccess();
        },
        onError: (error: { errors: string[] }) => {
            return error;
        }
    });
};

export default useMemberCheckin;
